/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Config from "../../../../../../../../Config";
const cdnUrl = Config.getCdnUrl();

// Countries flags
const US = cdnUrl + "/assets/images/icons/flags/US.png";
const DE = cdnUrl + "/assets/images/icons/flags/DE.png";
const GB = cdnUrl + "/assets/images/icons/flags/GB.png";
const BR = cdnUrl + "/assets/images/icons/flags/BR.png";
const AU = cdnUrl + "/assets/images/icons/flags/AU.png";

const salesTableData = [
  {
    country: [US, "united state"],
    sales: 2500,
    bounce: "29.9%",
  },
  {
    country: [DE, "germany"],
    sales: "3.900",
    bounce: "40.22%",
  },
  {
    country: [GB, "great britain"],
    sales: "1.400",
    bounce: "23.44%",
  },
  { country: [BR, "brasil"], sales: 562, bounce: "32.14%" },
  { country: [AU, "australia"], sales: 400, bounce: "56.83%" },
];

export default salesTableData;
